import { useCallback, useEffect, useMemo, useState } from 'react';

/**
 * Multi-select state for the Add Forms modal. Selection clears while the modal is closed
 * and confirmed forms keep catalog order, which is the order they are appended to the widget.
 *
 * @param {boolean} open
 * @param {{ id: string, name: string }[]} forms - Active catalog options
 */
export const useAddFormsSelection = (open, forms) => {
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (!open) {
      setSelectedIds([]);
    }
  }, [open]);

  const toggleForm = useCallback((formId) => {
    setSelectedIds((current) =>
      current.includes(formId) ? current.filter((id) => id !== formId) : [...current, formId],
    );
  }, []);

  const selectedForms = useMemo(
    () => forms.filter((form) => selectedIds.includes(form.id)),
    [forms, selectedIds],
  );

  const isSelected = useCallback((formId) => selectedIds.includes(formId), [selectedIds]);

  return { isSelected, toggleForm, selectedForms };
};
